import React, { FunctionComponent } from 'react';

import { Partner } from 'app/api/@generated/backend';

import { altiboxLogoImageProps } from 'app/resources/images';

import { StyledDefaultLogo, StyledImage } from './partner-logo.styled';

interface Props {
    partner?: Partner;
}

export const PartnerLogo: FunctionComponent<Props> = (props) => {
    const { partner } = props;

    if (!partner?.logoUrl) {
        return <StyledDefaultLogo {...altiboxLogoImageProps} />;
    }

    return <StyledImage src={partner.logoUrl} alt={partner.name} />;
};
